import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { get } from "lodash";
import { NotificationManager } from "react-notifications";

import { getWorkoutPlanDetails, addPlanToMyWorkout } from "../../../store/actions";
import Tooltip from "../../../sharedComponents/tooltip";

const WorkoutDetails = ({ match, getWorkoutPlanDetails, workoutDetails, history, addPlanToMyWorkout }) => {
	const workoutId = (match && match.params && match.params.id) || null;
	const details = workoutDetails && workoutDetails.plan_details ? workoutDetails.plan_details : "";
	const schedule = workoutDetails && workoutDetails.work_schedule ? workoutDetails.work_schedule : "";
	const keyList = Object.keys(schedule);
	const notesHtml = details.notes_html ? details.notes_html.replace(/\n/g, "<br>") : "";

	useEffect(() => {
		getWorkoutPlanDetails(workoutId);
	}, [getWorkoutPlanDetails, workoutId]);

	const goToPage = (id) => {
		history.push(`/fitness/exercises/${id}/details`);
	};

	const [submitting, setSubmitting] = useState(false);
	const submitPlan = () => {
		setSubmitting(true);
		const successHandler = (event) => {
			if (event.status >= 200 && event.status < 300) {
				history.push("/fitness/my-workout");
				return NotificationManager.success("Plan added!", "", 5000);
			}

			return setSubmitting(false);
		};
		addPlanToMyWorkout({ plan: workoutId }, successHandler);
	};

	return (
		<div className="container">
			<div className="row mt-3 d-flex flex-row pb-5">
				<div className="col-8">
					<div className="card card-primary p-4 br-2 border-0 h-100">
						<div className="d-flex flex-row d-flex justify-content-between">
							<h2 className="mb-3 font-weight-bold"> {details.name}</h2>
							{submitting ? (
								<button className="btn btn-primary btn-cell" disabled>
									<i className="icon icon-add-to-plan" />
								</button>
							) : (
								<Tooltip content="Add Exercise to My Workout" disabled={submitting}>
									<button className="btn btn-primary btn-cell" onClick={submitPlan}>
										<i className="icon icon-add-to-plan" />
									</button>
								</Tooltip>
							)}
						</div>
						<h4 className="text-primary-dark font-weight-bold pb-2 border-bottom"> {details.description}</h4>
						<div className="mt-4" dangerouslySetInnerHTML={{ __html: notesHtml }} />
					</div>
				</div>
				<div className="col-4">
					<div className="card card-primary p-4 br-2 border-0 h-100">
						<h4 className="text-primary-dark font-weight-bold"> The workout schedule </h4>
						{keyList &&
							keyList.map((item, j) => {
								const list = schedule[item];
								return list && list.length ? (
									<div key={j}>
										<p className="border-bottom text-primary font-weight-bold"> {item} </p>
										<div className="mb-3">
											{list.map((i, index) => {
												return (
													<div key={index}>
														<p className="mb-1">
															{i.time} minutes &bull;{" "}
															<span
																className="text-primary-dark pointer"
																onClick={() => goToPage(i.id)}>
																{" "}
																{i.name}
															</span>
														</p>
													</div>
												);
											})}
										</div>
									</div>
								) : null;
							})}
					</div>
				</div>
			</div>
		</div>
	);
};

const mapDispatchToProps = { getWorkoutPlanDetails, addPlanToMyWorkout };

const mapStateToProps = (state) => {
	return {
		workoutDetails: get(state.WorkoutPlans, "workoutPlanDetails", {})
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(WorkoutDetails);
